export const NOMINATED_REWARDS_ENDPOINTS = {
  GET_NOMINEE_LIST_BY_ID: 'api/v1/nomination/nominee-votes',
  GET_NOMINATION_CONFIGURATION: 'api/v1/nomination/configuration',
  GET_EMPLOYEE_LOGIN_TYPE: 'api/v1/employees/login-type',
  CREATE_NOMINATION_CONFIGURATION: 'api/v1/nomination/configuration'
}